// frontend/src/components/grid/LoadingOverlay.jsx
// Shared AG Grid loading overlay — shimmer rows in the active SaaS theme.
// Wired into every grid via overlayComponentSelector in utils/gridDefaults.js.

import './GridOverlays.css';

const SKELETON_ROWS = 8;

export default function LoadingOverlay() {
  return (
    <div className="grid-overlay grid-loading-overlay" role="presentation" aria-busy="true">
      {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
        <div key={i} className="grid-loading-row" />
      ))}
    </div>
  );
}
